import React from 'react';
import { L as LAYOUTS } from '../../helpers-d59c72d9.js';
import { withRCEHelpers } from '../rce-helpers-context/index.js';
import { PollGridOption } from './PollGridOption.js';
import { PollListOption } from './PollListOption.js';
export { OptionPropTypes } from './types.js';
import { PollListOptionWebview } from './webview/PollListOptionWebview.js';
import { PollGridOptionWebview } from './webview/PollGridOptionWebview.js';
import 'wix-rich-content-common/libs/imageUtils';
import 'prop-types';
import 'classnames';
import 'wix-rich-content-common/libs/Tooltip';
import './PollOptionBase.js';
import '../../option-8d036ac1.js';
import '../../style-inject.es-746bb8ed.js';
import '../../assets/icons/NonEditableIcon.js';
import '../../assets/icons/CheckIcon.js';
import '../image-upload/ImageUpload.js';
import 'react-measure';
import '../image-upload/types.js';
import '../../assets/icons/LoaderIcon.js';
import '../../assets/icons/ReplaceIcon.js';
import '../text-field/TextField.js';
import 'lodash';
import '../../assets/icons/RemoveIcon.js';
import '../poll-context/types.js';
import '../../option-webview-740347b7.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const PollOption = withRCEHelpers((props) => {
  var _a, _b;
  const { layout, rce } = props;
  if (rce.isWebView) {
    switch ((_a = layout.poll) == null ? void 0 : _a.type) {
      case LAYOUTS.GRID:
        return /* @__PURE__ */ React.createElement(PollGridOptionWebview, __spreadValues({}, props));
      case LAYOUTS.LIST:
      default:
        return /* @__PURE__ */ React.createElement(PollListOptionWebview, __spreadValues({}, props));
    }
  }
  switch ((_b = layout.poll) == null ? void 0 : _b.type) {
    case LAYOUTS.GRID:
      return /* @__PURE__ */ React.createElement(PollGridOption, __spreadValues({}, props));
    case LAYOUTS.LIST:
    default:
      return /* @__PURE__ */ React.createElement(PollListOption, __spreadValues({}, props));
  }
});

export { PollOption };
//# sourceMappingURL=index.js.map
